<template>
  <van-popup 
    class="popup" 
    v-model="show" 
    position="right" 
    closeable 
    @close="close"
  >
    <p>筛选项</p>
    
    <filter-item title="距离" :data="distance" ref="distance" />
    <filter-item title="门诊类型" :data="type" ref="type" />
    <filter-item title="服务时间" :data="time" ref="time" />

    <div class="my-buttons">
      <van-button round size="small" @click="reset">重置</van-button>
      <van-button round size="small" type="info" @click="confirm">确定</van-button>
    </div>
  </van-popup>
</template>

<script>
import FilterItem from './FilterItem'
import { povType as type } from 'utils/handlePovType'

export default {
  components: {
    FilterItem
  },
  data() {
    return {
      show: false,
      type,
      distance: [
        { value: 500, label: '500m以内' },
        { value: 1000, label: '1km以内' },
        { value: 3000, label: '3km以内' },
        { value: 5000, label: '5km以内' },
        { value: 10000, label: '10km以内' }
      ],
      time: [
        { value: true, label: '24小时服务' },
        { value: false, label: '非24小时服务' }
      ]
    }
  },
  methods: {
    confirm() {
      const obj = {
        distance: this.$refs.distance.value,
        type: this.$refs.type.value,
        time: this.$refs.time.value
      }
      
      let k = 0
      for (let i in obj) {
        if (obj[i] !== '') k++
      }
      if (!k) {
        return this.$toast({
          message: '请筛选条件',
          position: 'bottom'
        })
      }

      this.show = false
      this.$emit('confirm', obj)

    },
    reset() {
      this.$refs.distance.reset()
      this.$refs.type.reset()
      this.$refs.time.reset()
    },
    close() {
      this.reset()
    },
    open() {
      this.show = true
    }
  }
}
</script>

<style lang="less" scoped>
.popup {
  width: 72%;
  height: 100%;
  padding: 70px 12px 50px 12px;
  box-sizing: border-box;
  p {
    font-weight: bold;
    margin-bottom: 14px;
  }
  .btn {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    .van-button {
      height: 41px;
      flex: 1;
    }
  }
}
</style>